<div class="progress w-full h-full" [class.loading]="loading" [style.--__percent]="value"></div>
